import React from "react";
import { observer } from "mobx-react";
import { Button, Group, Modal, Stack, Title, Text, Box } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import { darkStyles, JsonView, collapseAllNested } from "react-json-view-lite";
import { makeChannelDisplayName } from "../../helpers/channels";
import {
  IconAbacus,
  IconBoltFilled,
  IconExternalLink,
} from "@tabler/icons-react";
import { TextWithInfo } from "../modals/textWithInfo";
import { useMediaQuery } from "@mantine/hooks";
import { cleanNullsAndSort, removeRawData } from "../../helpers/sort";
import ChannelKeyData from "./channelKeyData";
import { TextWithInfoAndIcon } from "./textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";

const renderTransactionLink = (transactionId: string, network: string) => {
  if (!transactionId) return null;
  const baseUrl =
    network === "testnet"
      ? "https://mempool.space/testnet/tx"
      : "https://mempool.space/tx";
  const url = `${baseUrl}/${transactionId}`;
  return (
    <Group justify="flex-end">
      <Button
        component="a"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        variant="default"
        style={{ maxWidth: "60%" }}
        color="blue"
        radius="md"
        rightSection={<IconExternalLink />}
      >
        Transaction
      </Button>
    </Group>
  );
};

const LedgerItemDetail = observer(({ cubby }: { cubby: Cubby }) => {
  const handleClose = () => {
    cubby.setCurrentlyFocusedLedgerItemId(null);
  };

  const isMobile = useMediaQuery("(max-width: 768px)");
  const modalWidth = isMobile ? "95%" : "70%";
  const data = cubby.currentlyFocusedLedgerItemJson[1];
  const kind = cubby.currentlyFocusedLedgerItemJson[0];
  const expandToLevel2 = (level) => level <= 2;
  return (
    <>
      {cubby.currentlyFocusedLedgerItemId && data && (
        <Modal
          opened={!!cubby.currentlyFocusedLedgerItemId}
          onClose={handleClose}
          size={modalWidth}
          title={kind}
        >
          <Stack>
            <JsonView
              data={removeRawData(cleanNullsAndSort(data))}
              shouldExpandNode={expandToLevel2}
              style={darkStyles}
            />
          </Stack>
        </Modal>
      )}
    </>
  );
});

export default LedgerItemDetail;
